<template>
  <modal name="modal_view">
    <div slot="header">
      <h2>
        {{ coinViewTitle }}
        <span style="margin-left:15px;" />
        <a v-bind:href="link" target="_blank">
          <el-tag size="mini" effect="plain">Chart</el-tag>
        </a>
        <a class="modal-default-button" @click.prevent="close">&times;</a>
      </h2>
    </div>
    <div slot="body">
      <center>
        <i class="el-icon-loading" v-if="isLoading"></i>
      </center>
      <table cellspacing="0" class="type3">
        <col />
        <col width="70" />
        <col width="51" />
        <col width="51" />
        <tr v-for="(value, i) in values" :key="i">
          <td>
            {{value.marketName}}
            <span class="font999">{{value.marketTarget}}</span>
          </td>
          <td class="num tah">
            <span v-html="value.marketPriceKRW"></span>
            <div v-html="value.marketDiff"></div>
          </td>
          <td class="num tah">
            <div v-html="value.marketDiffPer"></div>
          </td>
          <td class="num tah font999" style="font-size:8pt;">{{value.marketFetchTime}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer">
      <div align="right">
        <el-tag type="info" size="small" @click.prevent="close" style="cursor:pointer;">Close</el-tag>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from './modal.vue'
export default {
  components: {
    modal
  },
  props: ['coinSite', 'coinName', 'coinPrice', 'coinPriceUpbit', 'coinPriceBithumb', 'coinPriceCoinone'],
  data () {
    return {
      link: '',
      coinViewTitle: '',
      coinPriceRet: '',
      values: [],
      isLoading: true
    }
  },
  created () {
    this.fetchData(this.coinSite, this.coinName, this.coinPrice, this.coinPriceUpbit, this.coinPriceBithumb, this.coinPriceCoinone)
  },
  methods: {
    fetchData: function (coinSite, coinName, coinPrice, coinPriceUpbit, coinPriceBithumb, coinPriceCoinone) {
      if (coinPrice > 0) this.coinPriceRet = coinPrice
      else if (coinPriceUpbit > 0) this.coinPriceRet = coinPriceUpbit
      else if (coinPriceBithumb > 0) this.coinPriceRet = coinPriceBithumb
      else if (coinPriceCoinone > 0) this.coinPriceRet = coinPriceCoinone
      this.coinViewTitle = coinName + ' ' + Number(this.coinPriceRet).toLocaleString()
      this.$axios
        .get('https://wisebody.co.kr/api/modalView.php', {
          params: {
            coinSite: coinSite,
            coinName: coinName,
            coinPrice: this.coinPriceRet
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.isLoading = false
            this.values = res.data
            if (coinSite === 'UPBIT') this.link = 'https://upbit.com/full_chart?code=CRIX.UPBIT.KRW-' + coinName
            else if (coinSite === 'UPBIT_BTC') this.link = 'https://upbit.com/full_chart?code=CRIX.UPBIT.BTC-' + coinName
            else if (coinSite === 'BITHUMB') this.link = 'https://www.bithumb.com/trade/chart/' + coinName + '_KRW'
            else if (coinSite === 'COINONE') this.link = 'https://coinone.co.kr/chart?site=coinone' + coinName.toLowerCase() + '&unit_time=30m'
            else if (coinSite === 'BINANCE') this.link = 'https://cryptowat.ch/ko/charts/BINANCE:' + coinName + '-USDT'
            else if (coinSite === 'BINANCE_BTC') this.link = 'https://cryptowat.ch/ko/charts/BINANCE:' + coinName + '-BTC'
            else if (coinSite === 'BITFINEX') this.link = 'https://cryptowat.ch/ko/charts/BITFINEX:' + coinName + '-USD'
            else this.link = '#'
          } else {
            console.log('Server Error')
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal_view.vue